import { CompanyOrgResponse, OrgEmployee } from "../model/teamHierachyModel";
import { UserManagementFlowAction } from "./userManagement.action";

export type UserManagementFlowState = {
  activeTab: "User Management" | "Team Hierarchy";
  teamHierarchy: CompanyOrgResponse;
};
export const userManagementInitialState: UserManagementFlowState = {
  activeTab: "User Management",
  teamHierarchy: {
    company_id: "",
    company_name: "",
    total_employees: 0,
    org_chart: [],
    unassigned: [],
    unassigned_count: 0,
  },
};
export function userManagementReducer(
  state: UserManagementFlowState,
  action: UserManagementFlowAction,
): UserManagementFlowState {
  switch (action.type) {
    case "SET_ACTIVE_TAB":
      return { ...state, activeTab: action.payload };
    case "SET_TEAM_HIERARCHY":
      return { ...state, teamHierarchy: action.payload };
    default:
      return state;
  }
}
